import React from 'react'
import { Trans } from 'react-i18next'

/** Dashboard statistic cards step component */
export const DashboardStatisticsStep: React.FC = () => {
  return <Trans i18nKey="emobility.tour.dasbhboard-statistics" components={{ strong: <strong /> }} />
}
